const TNH_SETUP = {
    title: "VNPT ILIS - Cổng thông tin địa chính",
    // googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAlcAU-VVbfnvJMQ_CZDmIBFIQ1jGYDVvk&libraries=geometry,drawing,places',
    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB9vaQPpsE8RxB7iG5W7oZYZtExGQTJmKk&libraries=geometry,drawing,places',
    defaultZoom: 18,
    huyenId: 706,
    iddvhc: '5D69DF6710A54EB89D1384CB3F18A6F0',
    tinhId: 72,
    distanceLoad: '200',
    ktt: 105.5,
    dXSDefult: 0.00101036464,
    dYSDefult: -0.00178137015, 
};

export default TNH_SETUP;
